<template>
    <div>
        <div class="add-contact-wrapper" v-if="flags.find(flag => flag.field_key === 'spokesperson').showField">
            <button v-b-tooltip.hover title="Add spokesperson"
                class="add-contact-button exclude-outside-click d-inline-block"
                @click="showAddSpokesperson">Spokesperson</button>
            <plus-button @click="showAddSpokesperson"></plus-button>
            <div class="custom-multiselect"
                v-show="flags.find(flag => flag.field_key === 'spokesperson').toggleContactSelect"
                v-click-outside="outside">
                <autocomplete :debounce-time="500" class="multiselect" :search="onSpokespersonSearch"
                    @focus="onSpokespersonSearch(false)" @submit="onSpokespersonSelect"
                    placeholder="Start typing to select spokesperson" aria-label="Start typing to select spokesperson"
                    ref="searchSpokesperson" auto-select>
                    <template v-slot:result="{ result, props }">
                        <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                            v-if="result.id == null">
                            <div class="option_add" v-html="result.label"></div>
                        </li>
                        <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                            v-if="result.id">
                            <div class="option__desc">
                                <div class="option__name exclude-outside-click">
                                    {{ result.first_name }} {{ result.last_name }}
                                </div>
                                <div class="option__company exclude-outside-click">{{ result.company_name }}</div>
                                <div class="option__phone exclude-outside-click">{{ result.phone }}</div>
                            </div>
                        </li>
                    </template>
                </autocomplete>
            </div>
            <div class="contact-box"
                v-for="(contact, index) in _.filter(deliverableDetail.customFields, { field_key: 'spokesperson' })"
                :key="'spokesperson-' + index" v-if="contact.value && contact.contactData">
                <div class="contact-box__name">
                    {{ contact.contactData.name }}
                    <a v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                        v-b-tooltip.hover title="Edit spokesperson" class="edit-contact-btn" href="#"
                        @click.prevent="updateContact(contact.contactData, 'spokesperson')">
                        <i class="fas fa-edit"></i>
                    </a>
                </div>
                <div v-if="contact.contactData.position" class="contact-box__position">
                    {{ contact.contactData.position }}
                </div>
                <div v-if="contact.contactData.company_name" class="contact-box__company_name">
                    {{ contact.contactData.company_name }}
                </div>
                <div v-if="contact.contactData.phone" class="contact-box__phone">
                    <a :href="Format.hrefPhone(contact.contactData.phone)">
                        T: {{ contact.contactData.phone }}</a>
                </div>
                <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone">
                    <a :href="Format.hrefPhone(contact.contactData.cell_phone)">
                        M: {{ contact.contactData.cell_phone }}</a>
                </div>
                <div v-if="contact.contactData.fax" class="contact-box__fax">
                    F:{{ contact.contactData.fax }}
                </div>
                <div v-if="contact.contactData.email_address" class="contact-box__email">
                    <a :href="Format.hrefEmail(contact.contactData.email_address)">
                        {{ contact.contactData.email_address }}</a>
                </div>
                <div v-if="contact.contactData.website" class="contact-box__website">
                    <a :href="Format.website(contact.contactData.website)">{{ contact.contactData.website }}</a>
                </div>
                <div v-if="contact.contactData.address" class="contact-box__address">{{ contact.contactData.address }}
                </div>
                <div v-if="contact.contactData.city" class="contact-box__city">
                    {{ Format.city(contact.contactData.city) }}
                </div>
                <div v-if="contact.contactData.province" class="contact-box__province">
                    {{ contact.contactData.province }}
                </div>
                <div v-if="contact.contactData.country_id" class="contact-box__country_id">
                    {{ contact.contactData.country_id }}
                </div>
                <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">
                    {{ Format.postalCode(contact.contactData.postal_code) }}
                </div>
                <div v-if="contact.contactData.region" class="contact-box__region">{{ contact.contactData.region }}
                </div>
                <div v-if="contact.contactData.notes" class="contact-box__notes">{{ contact.contactData.notes }}</div>
            </div>
        </div>

        <div class="add-contact-wrapper" v-if="flags.find(flag => flag.field_key === 'who').showField">
            <button v-b-tooltip.hover title="Add contact"
                class="add-contact-button exclude-outside-click d-inline-block" @click="showAddWho">
                {{ deliverableContactsLabel(deliverableDetail.deliverable_template_id) }}</button>
            <plus-button @click="showAddWho"></plus-button>
            <div class="custom-multiselect" v-show="flags.find(flag => flag.field_key === 'who').toggleContactSelect"
                v-click-outside="outside">
                <autocomplete :debounce-time="500" class="multiselect" :search="onWhoSearch" @submit="onWhoSelect"
                    placeholder="Start typing to select outlet / contact"
                    aria-label="Start typing to select outlet / contact" ref="searchWho" auto-select>
                    <template v-slot:result="{ result, props }">
                        <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                            v-if="result.id == null">
                            <div class="option_add" v-html="result.label"></div>
                        </li>
                        <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                            v-if="result.id">
                            <div class="option__desc">
                                <div class="option__name exclude-outside-click">
                                    {{ result.first_name }} {{ result.last_name }}
                                </div>
                                <div class="option__company exclude-outside-click">{{ result.company_name }}</div>
                                <div class="option__phone exclude-outside-click">{{ result.phone }}</div>
                            </div>
                        </li>
                    </template>
                </autocomplete>
            </div>
            <div class="contact-box"
                v-for="(contact, index) in _.filter(deliverableDetail.customFields, { field_key: 'who' })"
                :key="'who-' + index" v-if="contact.value && contact.contactData">
                <div class="contact-box__name">
                    {{ contact.contactData.name }}
                    <a v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                        v-b-tooltip.hover title="Edit contact" class="edit-contact-btn" href="#"
                        @click.prevent="updateContact(contact.contactData, 'who')">
                        <i class="fas fa-edit"></i>
                    </a>
                </div>
                <div v-if="contact.contactData.position" class="contact-box__position">
                    {{ contact.contactData.position }}
                </div>
                <div v-if="contact.contactData.company_name" class="contact-box__company_name">
                    {{ contact.contactData.company_name }}
                </div>
                <div v-if="contact.contactData.phone" class="contact-box__phone">
                    <a :href="Format.hrefPhone(contact.contactData.phone)">
                        T: {{ contact.contactData.phone }}</a>
                </div>
                <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone">
                    <a :href="Format.hrefPhone(contact.contactData.cell_phone)">
                        M: {{ contact.contactData.cell_phone }}</a>
                </div>
                <div v-if="contact.contactData.fax" class="contact-box__fax">
                    F:{{ contact.contactData.fax }}
                </div>
                <div v-if="contact.contactData.email_address" class="contact-box__email">
                    <a :href="Format.hrefEmail(contact.contactData.email_address)">
                        {{ contact.contactData.email_address }}</a>
                </div>
                <div v-if="contact.contactData.website" class="contact-box__website">
                    <a :href="Format.website(contact.contactData.website)">{{ contact.contactData.website }}</a>
                </div>
                <div v-if="contact.contactData.address" class="contact-box__address">{{ contact.contactData.address }}
                </div>
                <div v-if="contact.contactData.city" class="contact-box__city">
                    {{ Format.city(contact.contactData.city) }}
                </div>
                <div v-if="contact.contactData.province" class="contact-box__province">
                    {{ contact.contactData.province }}
                </div>
                <div v-if="contact.contactData.country_id" class="contact-box__country_id">
                    {{ contact.contactData.country_id }}
                </div>
                <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">
                    {{ Format.postalCode(contact.contactData.postal_code) }}
                </div>
                <div v-if="contact.contactData.region" class="contact-box__region">{{ contact.contactData.region }}
                </div>
                <div v-if="contact.contactData.notes" class="contact-box__notes">{{ contact.contactData.notes }}</div>
            </div>
        </div>

        <div v-for="flag in filteredFlags" :key="flag.field_key">
            <div class="add-contact-wrapper" v-if="flags.find(f => f.field_key === flag.field_key).showField">
                <button v-b-tooltip.hover :title="`Add ${flag.label}`"
                    class="add-contact-button exclude-outside-click d-inline-block"
                    @click="showAddCfContact(flag.field_key)">
                    {{ flag.label }}</button>
                <plus-button :title="`Add ${flag.label}`" @click="showAddCfContact(flag.field_key)"></plus-button>
                <div class="custom-multiselect"
                    v-show="flags.find(f => f.field_key === flag.field_key).toggleContactSelect"
                    v-click-outside="outside">
                    <autocomplete :debounce-time="500" class="multiselect" :search="onCfContactSearch"
                        @submit="onCfContactSelect" placeholder="Start typing to select contact"
                        aria-label="Start typing to select contact" :ref="`search-${flag.field_key}`" auto-select>
                        <template v-slot:result="{ result, props }">
                            <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                                v-if="result.id == null">
                                <div class="option_add" v-html="result.label"></div>
                            </li>
                            <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                                v-if="result.id">
                                <div class="option__desc">
                                    <div class="option__name exclude-outside-click">
                                        {{ result.first_name }} {{ result.last_name }}
                                    </div>
                                    <div class="option__company exclude-outside-click">{{ result.company_name }}</div>
                                    <div class="option__phone exclude-outside-click">{{ result.phone }}</div>
                                </div>
                            </li>
                        </template>
                    </autocomplete>
                </div>
                <div class="contact-box"
                    v-for="(contact, index) in _.filter(filteredContactList, { field_key: flag.field_key })"
                    :key="`${flag.field_key}-${index}`" v-if="contact.value && contact.contactData">
                    <div class="contact-box__name">
                        {{ contact.contactData.name }}
                        <a v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                            v-b-tooltip.hover :title="`Edit ${flag.label}`" class="edit-contact-btn" href="#"
                            @click.prevent="updateCfContact(contact.contactData, contact.children, flag.field_key)">
                            <i class="fas fa-edit"></i>
                        </a>
                    </div>
                    <div v-if="contact.contactData.position" class="contact-box__position">
                        {{ contact.contactData.position }}
                    </div>
                    <div v-if="contact.contactData.company_name" class="contact-box__company_name">
                        {{ contact.contactData.company_name }}
                    </div>
                    <div v-if="contact.contactData.phone" class="contact-box__phone">
                        <a :href="Format.hrefPhone(contact.contactData.phone)">
                            T: {{ contact.contactData.phone }}</a>
                    </div>
                    <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone">
                        <a :href="Format.hrefPhone(contact.contactData.cell_phone)">
                            M: {{ contact.contactData.cell_phone }}</a>
                    </div>
                    <div v-if="contact.contactData.fax" class="contact-box__fax">
                        F:{{ contact.contactData.fax }}
                    </div>
                    <div v-if="contact.contactData.email_address" class="contact-box__email">
                        <a :href="Format.hrefEmail(contact.contactData.email_address)">
                            {{ contact.contactData.email_address }}</a>
                    </div>
                    <div v-if="contact.contactData.website" class="contact-box__website">
                        <a :href="Format.website(contact.contactData.website)">{{ contact.contactData.website }}</a>
                    </div>
                    <div v-if="contact.contactData.address" class="contact-box__address">{{ contact.contactData.address
                        }}
                    </div>
                    <div v-if="contact.contactData.city" class="contact-box__city">
                        {{ Format.city(contact.contactData.city) }}
                    </div>
                    <div v-if="contact.contactData.province" class="contact-box__province">
                        {{ contact.contactData.province }}
                    </div>
                    <div v-if="contact.contactData.country_id" class="contact-box__country_id">
                        {{ contact.contactData.country_id }}
                    </div>
                    <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">
                        {{ Format.postalCode(contact.contactData.postal_code) }}
                    </div>
                    <div v-if="contact.contactData.region" class="contact-box__region">{{ contact.contactData.region }}
                    </div>
                    <div v-if="contact.contactData.notes" class="contact-box__notes">{{ contact.contactData.notes }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Format from "../../utility/Format";
import Autocomplete from '@trevoreyre/autocomplete-vue';

export default {
    data() {
        return {
            Format,
            currentFieldKey: "",
            flags: [],
        }
    },
    components: {
        Autocomplete,
    },
    props: [
        "deliverableDetail",
    ],
    computed: {
        ...mapGetters([
            "deliverableContactsLabel",
            "userAbilities",
        ]),
        // so that we can use lodash in the template
        _() {
            return _;
        },
        filteredFlags() {
            return this.flags.filter(flag => flag.field_key !== 'who' && flag.field_key !== 'spokesperson');
        },
        filteredContactList() {
            const childObjArray = this.deliverableDetail.customFields.filter(item => item.parent_id != null);
            const cfArray = this.deliverableDetail.customFields;
            if (childObjArray) {
                // loop through all this.deliverableDetail.customFields 
                // and if item.id == childObj.parent_id then add role object as child 
                childObjArray.forEach(child => {
                    cfArray.forEach(item => {
                        if (!item.children) {
                            this.$set(item, "children", []);
                        }
                        if (item.id == child.parent_id &&
                            item.field_id == child.field_parent_id &&
                            item.field_type == "contacts" &&
                            child.value_set) {
                            const valueSet = this.parseValue(child.value_set);
                            if (valueSet == false) {
                                // if we don't check for false... it throws up errors
                            } else {
                                const matchingObject = valueSet.find(item => item.slug === child.value);
                                item.children.push({
                                    ...matchingObject,
                                    ...child,
                                });
                            }
                        }
                    });
                });
            }
            return cfArray;
        }
    },
    methods: {
        parseValue(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return false;
            }
        },
        showAddSpokesperson() {
            if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
            this.clearFlags();
            this.resetFlag('spokesperson', true);
            this.$nextTick(() => {
                this.$refs.searchSpokesperson.$refs.input.focus();
            });
        },
        showAddWho() {
            if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
            this.clearFlags();
            this.resetFlag('who', true);
            this.$nextTick(() => {
                this.$refs.searchWho.$refs.input.focus();
            });
        },
        clearFlags() {
            this.flags.forEach(flag => {
                flag.toggleContactSelect = false;
            });
        },
        updateContact(contactData, fieldKey) {
            let payload = {
                currentContactData: contactData,
                currentContactId: contactData.id,
                currentFieldKey: fieldKey,
            };
            this.$store.dispatch('updateEditContactRelatedValues', payload);

            switch (fieldKey) {
                case "who":
                    this.$bvModal.show("editWhoModal");
                    break;
                case "spokesperson":
                    this.$bvModal.show("editSpokespersonModal");
                    break;
                default:
                    this.$bvModal.show("editCfContactModal");
                    break;
            }
        },

        onSpokespersonSearch(input) {
            return new Promise((resolve, reject) => {
                input = input == false ? '' : input
                axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
                    .then(resp => {
                        let contacts = [];
                        let x = 0;
                        contacts.push({
                            id: null,
                            label: "Create new contact <strong>" + input + "</strong>",
                            search: input,
                            deliverablId: this.deliverableDetail.deliverableId
                        });
                        for (x = 0; x < resp.data.length; x++) {
                            contacts.push(resp.data[x]);
                        }
                        this.$store.commit('setInitialData', { contacts: contacts })
                        resolve(contacts);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        onSpokespersonSelect(selected) {
            if (selected.id == null) {
                // add new contact..
                this.newContactId = null;
                this.createSpokesperson(selected.search, this.deliverableDetail.deliverableId);
            } else {
                this.newContactId = selected;
                this.inputAddContact('spokesperson');
            }
            this.$refs.searchSpokesperson.value = null;
            this.resetFlag('spokesperson', false);
        },
        createSpokesperson(newContactName, deliverableId) {
            this.$store.state.newContactName = newContactName;
            this.$store.state.deliverableId = deliverableId;
            this.$store.state.currentFieldKey = 'spokesperson';
            this.$bvModal.show("createSpokespersonModal");
        },
        createWho(newContactName, deliverableId) {
            this.$store.state.newContactName = newContactName;
            this.$store.state.deliverableId = deliverableId;
            this.$store.state.currentFieldKey = 'who';
            this.$bvModal.show("createWhoModal");
        },
        onWhoSearch(input) {
            return new Promise((resolve, reject) => {
                input = input == false ? '' : input
                axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
                    .then(resp => {
                        let contacts = [];
                        let x = 0;
                        contacts.push({
                            id: null,
                            label: "Create new contact <strong>" + input + "</strong>",
                            search: input,
                            deliverablId: this.deliverableDetail.deliverableId
                        });
                        for (x = 0; x < resp.data.length; x++) {
                            contacts.push(resp.data[x]);
                        }
                        this.$store.commit('setInitialData', { contacts: contacts })
                        resolve(contacts);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        onWhoSelect(selected) {
            if (selected.id == null) {
                // add new contact..
                this.newContactId = null;
                this.createWho(selected.search, this.deliverableDetail.deliverableId);
            } else {
                this.newContactId = selected;
                this.inputAddContact('who');
            }
            this.$refs.searchWho.value = null;
            this.resetFlag('who', false);
        },

        updateCfContact(contactData, children, fieldKey) {
            let ccData = contactData;
            ccData.children = children;
            let payload = {
                currentContactData: ccData,
                currentContactId: contactData.id,
                currentFieldKey: fieldKey,
            };
            this.$store.dispatch('updateEditContactRelatedValues', payload);

            switch (fieldKey) {
                case "who":
                    this.$bvModal.show("editWhoModal");
                    break;
                case "spokesperson":
                    this.$bvModal.show("editSpokespersonModal");
                    break;
                default:
                    this.$bvModal.show("editCfContactModal");
                    break;
            }
        },
        showAddCfContact(fieldKey) {
            if (this.deliverableDetail.permissions.viewOnly) return;
            this.clearFlags();
            this.resetFlag(fieldKey, true);
            this.$nextTick(() => {
                const refName = `search-${fieldKey}`;
                if (this.$refs[refName] &&
                    this.$refs[refName][0] &&
                    this.$refs[refName][0].$refs &&
                    this.$refs[refName][0].$refs.input) {
                    this.$refs[refName][0].$refs.input.focus();
                }
            });
        },
        createCfContact(newContactName, deliverableId, fieldKey) {
            let payload = {
                newContactName,
                deliverableId,
                fieldKey,
                currentContactTemplateType: "deliverable",
            };
            this.$store.dispatch('updateNewContactRelatedValues', payload);
            this.$bvModal.show("createCfContactModal");
        },
        onCfContactSearch(input) {
            return new Promise((resolve, reject) => {
                input = input == false ? '' : input
                axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
                    .then(resp => {
                        let contacts = [];
                        let x = 0;
                        //TODO:: use label of field to create new dept contact
                        contacts.push({
                            id: null,
                            label: "Create new contact <strong>" + input + "</strong>",
                            search: input,
                            deliverablId: this.deliverableDetail.deliverableId
                        });
                        for (x = 0; x < resp.data.length; x++) {
                            contacts.push(resp.data[x]);
                        }
                        this.$store.commit('setInitialData', { contacts: contacts })
                        resolve(contacts);
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        onCfContactSelect(selected) {
            const flagWithToggleTrue = this.flags.find(flag => flag.toggleContactSelect);
            if (flagWithToggleTrue) {
                // set current selected field type and pass it in api
                this.currentFieldKey = flagWithToggleTrue.field_key;
                if (selected.id == null) {
                    // add new contact..
                    this.newContactId = null;
                    this.createCfContact(selected.search, this.deliverableDetail.deliverableId, this.currentFieldKey);
                } else {
                    this.newContactId = selected;
                    this.inputAddContact(this.currentFieldKey);
                }
                const refName = `search-${this.currentFieldKey}`;
                if (this.$refs[refName] &&
                    this.$refs[refName][0]) {
                    this.$refs[refName][0].value = null;
                }
                this.resetFlag(this.currentFieldKey, false);
            } else {
                console.warn("No flag found with toggleContactSelect true");
            }
        },
        addDeliverableCfContact(payload) {
            this.$store.dispatch("addDeliverableCfContact", payload);
            this.newContactId = "";
        },

        inputAddContact(field_key) {
            let x = 0;
            let field_id = null;
            for (x = 0; x < this.deliverableDetail.customFields.length; x++) {
                if (this.deliverableDetail.customFields[x].field_key == field_key) {
                    field_id = this.deliverableDetail.customFields[x].field_id;
                    break;
                }
            }
            this.newContactId.fieldId = field_id;
            switch (field_key) {
                case "who":
                    this.addDeliverableWho({ contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId });
                    break;
                case "spokesperson":
                    this.addDeliverableSpokesperson({ contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId });
                    break;
                default:
                    this.addDeliverableCfContact({
                        contactData: this.newContactId,
                        deliverableId: this.deliverableDetail.deliverableId,
                        selectedFieldKey: this.currentFieldKey,
                    });
                    break;
            }
        },

        addDeliverableSpokesperson(payload) {
            this.$store.dispatch("addDeliverableSpokesperson", payload);
            this.newContactId = "";
        },
        addDeliverableWho(payload) {
            this.$store.dispatch("addDeliverableWho", payload);
            this.newContactId = "";
        },

        resetFlag(fieldKey, flagValue) {
            const flagIndex = this.flags.findIndex(flag => flag.field_key === fieldKey);
            if (flagIndex !== -1) {
                this.flags[flagIndex].toggleContactSelect = flagValue;
            }
        },

        setShowFieldFlags() {
            this.flags = this.deliverableDetail.contactTypeFields;
            const contactCustomFields = _.filter(this.deliverableDetail.templateCustomFields, { field_type: 'contacts' });
            if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
                // array exist, is not empty
                contactCustomFields.forEach(ccField => {
                    // Check the field_key of each object and set the corresponding flag to true
                    const flagIndex = this.flags.findIndex(flag => flag.field_key === ccField.field_key);
                    if (flagIndex !== -1) {
                        this.flags[flagIndex].showField = true;
                    }
                });
            }
        },

        outside() {
            this.addContactFlag = false;
            this.clearFlags();
        },
    },
    watch: {
        deliverableDetail: {
            handler() {
                this.setShowFieldFlags();
            },
            deep: true,
            immediate: true
        }
    },
}
</script>